<div>
    <p class="heading">Add Nominee</p>
    <p class="secondary-text">Add a nominee for your investments</p>
    <app-nominee-form></app-nominee-form>
</div>
<div class="row" style="margin-top: 20px; margin-bottom: 20px">
    <div class="col-xs-6">
        <button mat-stroked-button class="button-back primary" type="button" [routerLink]="backLink()">
            <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
        </button>
    </div>
    <div class="col-xs-6" *ngIf="isNextEnabled()">
        <div class="pull-right">
            <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading"
                                (click)="onSubmit()">
                NEXT
            </app-forward-button>
        </div>
    </div>
    <div class="col-xs-6" *ngIf="!isNextEnabled()">
        <div class="pull-right">
            <app-forward-button class="button-forward" [routerLink]="forwardLink()"
                                (click)="analyticsTracker.trackButtonClick('Nominee Information', 'Skip')">
                SKIP THIS STEP
            </app-forward-button>
        </div>
    </div>
</div>
